import { combineClassNames } from '@common/utils/combineClassNames';
import React, { memo } from 'react';

type Option = {
  value: string,
  label: string,
  description: string
};

type Props = {
  value: string | null;
  onChange: (...args: any[]) => any;
  options: Option[];
  className?: string;
  disabled?: boolean;
};

const QuizChoiceInput = memo(({
 value, onChange, options, className, disabled = false
}: Props) => {
  return (
    <div className={combineClassNames('QuizChoiceInput', className)}>
      {
        options.map((option: Option) => {
          const classNames = ['QuizChoiceInput__Item'];
          if (value === option.value) {
            classNames.push('QuizChoiceInput__Item--active');
          }
          if (disabled) {
            classNames.push('QuizChoiceInput__Item--disabled');
          }

          return (
            <div
              role="button"
              key={option.value}
              className={classNames.join(' ')}
              onClick={disabled ? undefined : () => onChange(option.value)}
            >
              <div className="QuizChoiceInput__Item__Name">
                <div>{ option.label }</div>
              </div>
              { option.description }
            </div>
          );
        })
      }
    </div>
  );
});

export default QuizChoiceInput;
